/* ==========================================================================
   Swaballs — lightweight AJAX cart for the custom (mockup) cart drawer.
   Drives: add-to-cart buttons (.sw-add), the slide-out cart drawer,
   the free-shipping progress bar, subtotal and cart counts.
   Config comes from window.SW (set in sections/sw-header.liquid).
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.SW || {};
  var MONEY = CFG.moneyFormat || '${{amount}}';
  var FREE_SHIP = typeof CFG.freeShipThreshold === 'number' ? CFG.freeShipThreshold : 0; // cents

  /* ---------- money formatting (Shopify-compatible) ---------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = cents || 0;
    function withCommas(num) {
      return num.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
    function fmt(precision, thousands, decimal) {
      if (isNaN(cents)) return 0;
      var value = (cents / 100.0).toFixed(precision);
      var parts = value.split('.');
      var dollars = withCommas(parts[0]).replace(/,/g, thousands || ',');
      var pennies = parts[1] ? (decimal || '.') + parts[1] : '';
      return dollars + pennies;
    }
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return fmt(2, ',', '.');
        case 'amount_no_decimals': return fmt(0, ',', '.');
        case 'amount_with_comma_separator': return fmt(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        default: return fmt(2, ',', '.');
      }
    });
  }

  var TINTS = ['sw-tint-blue', 'sw-tint-purple', 'sw-tint-mint'];

  /* ---------- DOM helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function openDrawer() {
    var t = document.getElementById('sw-carttoggle');
    if (t) t.checked = true;
  }
  function closeDrawer() {
    var t = document.getElementById('sw-carttoggle');
    if (t) t.checked = false;
  }

  /* ---------- render ---------- */
  function lineMarkup(item, i) {
    var tint = TINTS[i % TINTS.length];
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1$2') + '" alt="" loading="lazy" width="52" height="52">'
      : '';
    var meta = [];
    if (item.variant_title && item.variant_title !== 'Default Title') meta.push(item.variant_title);
    meta.push('Qty ' + item.quantity);
    return '' +
      '<div class="sw-cart-line" data-key="' + item.key + '">' +
        '<div class="sw-cart-thumb ' + tint + '">' + img + '</div>' +
        '<div class="sw-cart-line-info">' +
          '<div class="sw-nm">' + item.product_title + '</div>' +
          '<div class="sw-mt">' + meta.join(' &middot; ') + '</div>' +
          '<button type="button" class="sw-cart-remove" data-key="' + item.key + '">Remove</button>' +
        '</div>' +
        '<div class="sw-pr">' + formatMoney(item.final_line_price) + '</div>' +
      '</div>';
  }

  function render(cart) {
    var body = $('.sw-cart-body');
    var count = cart.item_count;

    // header + drawer counts
    $all('.sw-cart-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
    var title = $('.sw-cart-title');
    if (title) title.textContent = 'Your cart (' + count + ')';

    // lines / empty state
    if (body) {
      if (count === 0) {
        body.innerHTML = '<div class="sw-cart-empty"><p>Your cart is empty.</p>' +
          '<label for="sw-carttoggle" class="sw-btn sw-btn-primary">Keep shopping</label></div>';
      } else {
        body.innerHTML = cart.items.map(lineMarkup).join('');
      }
    }

    // subtotal
    var sub = $('.sw-cart-sub-val');
    if (sub) sub.textContent = formatMoney(cart.items_subtotal_price);

    // free-shipping progress
    var bar = $('.sw-free-bar i');
    var note = $('.sw-cart-note');
    if (FREE_SHIP > 0) {
      var remain = FREE_SHIP - cart.items_subtotal_price;
      var pct = Math.max(0, Math.min(100, (cart.items_subtotal_price / FREE_SHIP) * 100));
      if (bar) bar.style.width = pct + '%';
      if (note) {
        note.innerHTML = remain > 0
          ? "You're " + formatMoney(remain) + ' away from free shipping.'
          : "You've unlocked free shipping &mdash; nice.";
      }
    }
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refresh() { return getCart().then(render); }

  /* ---------- actions ---------- */
  function addToCart(id, qty, btn) {
    if (btn) { btn.classList.add('sw-loading'); btn.setAttribute('aria-busy', 'true'); }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw res.data;
        return refresh();
      })
      .then(function () { openDrawer(); })
      .catch(function (e) { console.warn('[Swaballs] add to cart failed', e); })
      .then(function () { if (btn) { btn.classList.remove('sw-loading'); btn.removeAttribute('aria-busy'); } });
  }

  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(render);
  }

  /* ---------- events (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest ? e.target.closest('.sw-add') : null;
    if (add) {
      var id = add.getAttribute('data-variant-id');
      if (id) { e.preventDefault(); addToCart(id, parseInt(add.getAttribute('data-quantity') || '1', 10), add); }
      return;
    }
    var rm = e.target.closest ? e.target.closest('.sw-cart-remove') : null;
    if (rm) { e.preventDefault(); removeLine(rm.getAttribute('data-key')); }
  });

  // keep drawer state in sync with real cart on load (covers browser back/forward)
  document.addEventListener('DOMContentLoaded', function () { refresh(); });
})();
